// extracted by mini-css-extract-plugin
export default {"wrap":"style-wrap-3qgAR","linkswrap":"style-linkswrap-3wLnY","links":"style-links-3yxrm","status":"style-status-bo_EK","disabled":"style-disabled-1WHnW"};